import { Box, useTheme, Typography, Icon } from '../../../../../../base';
import { StyledOptionsContainer } from '../../JobQuestions.styles';
import { useTranslation } from 'react-i18next';

export const QuestionFileUpload = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <StyledOptionsContainer>
            <Box
                sx={{
                    width: '100%',
                    height: '140px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: theme.spacing(1),
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: theme.spacing(1),
                    border: `2px dashed ${theme.palette.grey[300]}`,
                    cursor: 'not-allowed',
                    opacity: 0.7,
                }}
            >
                <Icon
                    name="AddCircleOutlineOutlinedIcon"
                    sx={{
                        fontSize: 40,
                        color: theme.palette.grey[400],
                    }}
                />
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.text.disabled,
                        fontStyle: 'italic',
                    }}
                >
                    {t('saveJob.fileUploadPlaceholder')}
                </Typography>
            </Box>
        </StyledOptionsContainer>
    );
};
